import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
  HttpRequest
} from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { AuthorizationBody } from './models/auth.interfaces';
import { AuthService } from './services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private _authService: AuthService, private _router: Router) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authorizationToken: string;

    // Don't intercept the /token request for authorization
    if (
      request.url.indexOf('token') > -1 ||
      request.url.toLowerCase().indexOf('login') > -1 ||
      request.url.toLowerCase().indexOf('passwordforget') > -1 ||
      request.url.toLowerCase().indexOf('resetpassword') > -1 ||
      request.url.indexOf('pagepublic') > -1 ||
      request.url.toLowerCase().indexOf('perfnav/logon/') > -1 ||
      request.url.toLowerCase().indexOf('api/logroute') > -1 ||
      request.url.toLowerCase().indexOf('api/route/log') > -1 ||
      request.url
        .toLowerCase()
        .indexOf('rs/recruitmenttechnologies/jobdetail') > -1 ||
      request.url.toLowerCase().indexOf('loginforget') > -1 ||
      request.url.toLowerCase().indexOf('candregister') > -1 ||
      request.url.toLowerCase().indexOf('candlogin') > -1 ||
      request.url.toLowerCase().indexOf('forgot-password') > -1 ||
      request.url.toLowerCase().indexOf('set-password') > -1 ||
      request.url.toLowerCase().indexOf('candidatedisclaimer') > -1
    ) {
      return next.handle(request);
    }

    return this._authService.getToken().pipe(
      switchMap((token: AuthorizationBody) => {
        if (token) {
          authorizationToken = token.token;
          let headers = {
            setHeaders: {
              Authorization: `Bearer ${token?.token}`,
              'Content-Type': 'application/json',
              'Cache-Control':
                'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
              Pragma: 'no-cache',
              Expires: '0',
            },
          };

          if (request.url.includes('api/conversation/addattachment') ||
            request.url.includes('api/recruitment-attachments/upload')) {
            delete headers.setHeaders["Content-Type"];
          }

          const cloned = request.clone(headers);

          return next.handle(cloned).pipe(
            tap(() => {
              setTimeout(() => {
                try {
                  (<any>window.top).initIframeResize();
                } catch (e) { }
              }, 500);
            })
          );
        } else {
          return next.handle(request);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (isDevMode()) {
          console.error(error.status, request.url);
        }

        if (error.status === 401) {
          this.handleError(401, authorizationToken);
        } else if (error.status >= 500) {
          if (!isDevMode()) {
            this.handleError(500);
          }
        } else if (error.status === 0) {
          console.error('HTTP transport failure', {
            url: error.url || request.url,
            statusText: error.statusText,
            online: navigator.onLine,
            eventType: error.error?.type,
          });
        }

        return throwError(() => error);
      })
    );
  }

  /**
   * Handle API authentication errors.
   */
  private handleError(code: number, failedToken?: string) {
    if (code === 401) {
      const currentToken = localStorage.getItem(this._authService.tokenStorageKey);

      // Ignore a late response from the session that was replaced by a new login.
      if (failedToken && failedToken !== currentToken) {
        return;
      }

      this._authService.clearStorage();
      this._router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    this._router.navigate(['/error'], { queryParams: { code } });
  }
}
